//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SetElement',
  props: ['element', 'hasOldPrice', 'price'],
  data() {
    return {
      currency: window.currency,
    }
  },
  computed: {
    discountPercent() {
      const oldPrice = Number(this.element.price)
      const price = Number(this.price)
      if (!oldPrice || !price || price >= oldPrice) return 0
      return Math.round((1 - price / oldPrice) * 100)
    },
  },
}
